import { render, staticRenderFns } from "./SizeSelect.vue?vue&type=template&id=cb7c5708&scoped=true"
import script from "./SizeSelect.vue?vue&type=script&lang=js"
export * from "./SizeSelect.vue?vue&type=script&lang=js"
import style0 from "./SizeSelect.vue?vue&type=style&index=0&id=cb7c5708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7c5708",
  null
  
)

export default component.exports